import { cn } from '@/lib/cn';
import type { TrashView } from '@/types/common';

interface ViewToggleProps {
  value: TrashView;
  onChange: (v: TrashView) => void;
  /** Optional count badges per tab. */
  counts?: Partial<Record<TrashView, number>>;
  className?: string;
}

const TABS: { value: TrashView; label: string }[] = [
  { value: 'active', label: 'Active' },
  { value: 'trash', label: 'Trash' },
];

/** Active | Trash segmented control for soft-delete list views. */
export function ViewToggle({ value, onChange, counts, className }: ViewToggleProps) {
  return (
    <div className={cn('inline-flex rounded-md border border-border bg-card p-0.5', className)}>
      {TABS.map((tab) => {
        const active = value === tab.value;
        const count = counts?.[tab.value];
        return (
          <button
            key={tab.value}
            type="button"
            onClick={() => onChange(tab.value)}
            className={cn(
              'rounded px-3 py-1.5 text-sm font-medium transition-colors',
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            {tab.label}
            {count != null && (
              <span className={cn('ml-1.5 text-xs', active ? 'opacity-80' : 'opacity-60')}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
